import { render, staticRenderFns } from "./AuthenticationWrapper.vue?vue&type=template&id=5421940e&scoped=true&"
import script from "./AuthenticationWrapper.vue?vue&type=script&lang=ts&"
export * from "./AuthenticationWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticationWrapper.vue?vue&type=style&index=0&id=5421940e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421940e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
